<template>
    <section class="import-products-index">
        <div class="col-md-12">
            <pim-header header="Import Related Product Attributes"></pim-header>
            <div>
                <product-alerts :status="alert" v-model="alert"></product-alerts>
            </div>

            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
            </transition>

            <div class="card panel panel-default">
                <div class="card-block">
                    <form action="">
                        <input type="hidden" name="_token" :value="csrfToken">

                        <div class="row">
                            <div class="col-md-12">
                                <div id="importCsvDropzone" class="ext-right border p-3">
                                    <vue-dropzone
                                        v-on:vdropzone-file-added="fileAdded"
                                        v-on:vdropzone-removed-file="fileRemoved"
                                        v-on:vdropzone-sending="fileSending"
                                        v-on:vdropzone-complete="uploadComplete"
                                        v-on:vdropzone-error="uploadFailed"
                                        id="assetDropzone"
                                        acceptedFiles="text/csv"
                                        withCredentials="true"
                                        ref="assetDropzone"
                                        :useCustomSlot=true
                                        :options="dropzoneOptions">
                                        <div class="dropzone-custom-content">
                                            <h3 class="dropzone-custome-title">Drop files here or click to upload</h3>
                                        </div>
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-1">
                                <button v-on:click="uploadCSV()" type="button" class="btn btn-primary">Import</button>
                            </div>
                            <div class="col-md-4">
                                <a
                                    class="btn btn-warning"
                                    :href="templateRoute"
                                >
                                    <i class="fa fa-file"></i> Download Example CSV Template
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import PimHeader from '../generic/pim-header';
    import ProductAlerts from '../products/product-details-alerts.vue';

    Vue.use(VueEvents);

    export default {
        name: 'import-related-product-attributes-index',
        props: ['csrfToken', 'templateRoute', 'uploadRoute'],
        components: {
            'pim-header': PimHeader,
            'product-alerts': ProductAlerts,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                hasFile: false,
                isLoading: false,
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                dropzoneOptions: {
                    addRemoveLinks: true,
                    url: this.uploadRoute,
                    thumbnailWidth: 150,
                    headers: {'X-CSRF-Token': this.csrfToken},
                    maxFiles: 1,
                    autoProcessQueue: false
                }
            }
        },
        methods: {
            fileAdded: function(file) {
                this.hasFile = true;
            },
            fileRemoved: function (file, error, xhr) {
                this.hasFile = false;
            },
            fileSending: function (file, xhr, formData) {
                
            },
            uploadComplete: function (response) {
                this.isLoading = false;
                
                if (response.xhr.status == 200) {
                    this.hasFile = false;
                    this.alert.status = "alert-success";
                    this.alert.message = 'Success, import initiated, we are redirecting you to the Jobs page.';
                    this.$refs.assetDropzone.removeAllFiles();
                    setTimeout(function() {
                        window.location = "/jobs";
                    }, 2000);
                } else {
                    this.alert.status = "alert-danger";
                    this.alert.message = response.xhr.responseText || 'There was an error, please try again later.';
                }
            },
            uploadFailed: function (file, message, xhr) {
                this.isLoading = false;
                this.alert.status = "alert-danger";
                this.alert.message = xhr.responseText || 'There was an error, please try again later.';
            },
            uploadCSV() {
                if (!this.hasFile) {
                    this.alert.status = "alert-danger";
                    this.alert.message = 'Please select or "drag and drop" a file.';
                    return;
                }

                this.isLoading = true;
                this.$refs.assetDropzone.processQueue();
            }
        }
    };
</script>

<style>
    #importCsvDropzone > .vue-dropzone > .dz-preview > .dz-progress {
        display: none;
    }
</style>